module.exports = __webpack_public_path__ + "media/roomBgm.879f2ffe.mp3";